import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import { FontIcon, IDropdownOption, Stack, Text } from "@fluentui/react";
import { renderToString } from "react-dom/server";
import { Marked, marked } from "marked";
// import { TeamsApp } from "@microsoft/teams-js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./Answer.module.css";

import { AskResponse, Citation } from "../../api";
import { getblob } from "../../api";
import { parseAnswer } from "./AnswerParser";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import supersub from "remark-supersub";
import CopyImg from "../../assets/CopyCliboard.png";
import CopyImgHover from "../../assets/CopyCliboardHover.png";

import LikeIcon from "../../assets/like.svg";
import DislikeIcon from "../../assets/dislike.svg";
import DownloadIcon from "../../assets/download.svg";
import soundIcon from "../../assets/sound.svg";
import copyIcon from "../../assets/copy.svg";
import { Height, RestaurantSharp } from "@mui/icons-material";
import "./Answer.module.css";
import { Menu, MenuItem } from "@mui/material";
import { DislikePopup } from "./Chat_Icons/DislikeIcon";
import { LikePopup } from "./Chat_Icons/LikeIcon";

import { ChatMessage } from "../../api/models";
import { historyUpdate } from "../../api/api";
import AvtarImg from "../../assets/woman.png";

import WordDownloadButton from "./Chat_Icons/WordContent";
import PDFDownloadButton from "./Chat_Icons/PDFContnet";
import TextDownloadButton from "./Chat_Icons/TextContent";
// import AvatarComponent  from "../Avatar/Avatar";
import MenuImg from "../../assets/icons8-menu-48.png";
import ShareImg from "../../assets/share.png";
import Outlook from "../../assets/icons8-outlook-48.png";
import { Translate } from "./Chat_Icons/Translate";
import translateIcon from "../../assets/icons8-translate-48.png";
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { AppStateContext } from "../../state/AppProvider";
interface Props {
  answer: AskResponse;
  onCitationClicked: (citedDocument: Citation) => void;
}

export const Answer = ({ answer, onCitationClicked }: Props) => {
  const appStateContext = useContext(AppStateContext);
  const [isRefAccordionOpen, { toggle: toggleIsRefAccordionOpen }] =
    useBoolean(false);
  const filePathTruncationLimit = 50;

  const parsedAnswer = useMemo(() => parseAnswer(answer), [answer]);
  const [chevronIsExpanded, setChevronIsExpanded] =
    useState(isRefAccordionOpen);

  const handleChevronClick = () => {
    setChevronIsExpanded(!chevronIsExpanded);
    toggleIsRefAccordionOpen();
  };

  const [translatedMessage, settranslatedMessage] = useState("");
  const [translatedLanguage, settranslatedLanguage] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);

  const eyeHandle = async (citation: Citation) => {
    let filename = citation.filepath;
    let cont_array = citation.url?.split("/");
    let container_name = cont_array?.slice(-2)[0];
    if (filename && citation.chunk_id && container_name) {
      let response = await getblob(filename, container_name);
      let sas_url = citation.url + "?" + response;
      window.open(sas_url, "_blank");
    }

    // if (citation.url) {
    //     let filename = citation.filepath
    //     if (filename){
    //     let response = await getBlobSas(filename)
    //     }
    //     //window.open(citation.url, "_blank");
    // }
    //setActiveCitation([citation.content, citation.id, citation.title ?? "", citation.filepath ?? "", "", ""]);
    //setIsCitationPanelOpen(true);
  };
  useEffect(() => {
    setChevronIsExpanded(isRefAccordionOpen);
  }, [isRefAccordionOpen]);

  const createCitationFilepath = (
    citation: Citation,
    index: number,
    truncate: boolean = false,
  ) => {
    let citationFilename = "";
    if (citation.filepath && citation.chunk_id) {
      if (truncate && citation.filepath.length > filePathTruncationLimit) {
        const citationLength = citation.filepath.length;
        citationFilename = `${citation.filepath.substring(
          0,
          20,
        )}...${citation.filepath.substring(citationLength - 20)} - Part ${
          parseInt(citation.chunk_id) + 1
        }`;
      } else {
        citationFilename = `${citation.filepath} - Part ${
          parseInt(citation.chunk_id) + 1
        }`;
      }
    } else if (citation.filepath && citation.reindex_id) {
      citationFilename = `${citation.filepath} - Part ${citation.reindex_id}`;
    } else if (citation.filepath) {
      citationFilename = `${citation.filepath} ${index}`;
    } else {
      citationFilename = `Citation ${index}`;
    }
    return citationFilename;
  };

  const [copy, setCopy] = useState<string>(CopyImg);

  const copyAnser = async () => {
    try {
      await navigator.clipboard.writeText(parsedAnswer.markdownFormatText);

      setCopy(CopyImgHover);

      setTimeout(() => {
        setCopy(CopyImg);
      }, 3000);

      //alert('Text copied to clipboard');
    } catch (error) {
      console.error("Copy failed: ", error);
    }
  };

  // console.log("content",answer.chat_Contnet)

  // const ExportOptions: IDropdownOption[] = [
  //     { key: 'Word', text: 'Word', data: { icon: <img src={Word2Img} alt="Word" style={iconStyle} /> } },
  //     { key: 'PDF', text: 'PDF', data: { icon: <img src={PDFIMG} alt="Word" style={iconStyle} /> } },
  //     { key: 'Text', text: 'Text', data: { icon: <img src={TextIMG} alt="Word" style={iconStyle} /> } },
  // ];

  const DownloadIcon: React.FC = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [exportMenuOpen, setExportMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleMenuOpen = (event: React.MouseEvent<SVGSVGElement>) => {
      setAnchorEl(event.currentTarget as unknown as HTMLElement);
      setExportMenuOpen(true);
    };

    const handleMenuClose = () => {
      setExportMenuOpen(false);
    };
    const handleClick = () => {
      //   console.log(answer.message_id, "Meaagse id");
      //   console.log("content", answer.chat_Contnet);
    };
    return (
      <>
        <div style={{ position: "relative", display: "inline-block" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 20.5 20.5"
            className="icons-post"
            style={{
              cursor: "pointer",
              // border: isHovered ? "1px solid #00000040" : "1px solid transparent",
              padding: "6px",
              borderRadius: "4px",
              color: "#5d5d5d",
              transition: "background-color 0.3s ease, border-color 0.3s ease",
              backgroundColor: isHovered ? " #f9f9f9" : "transparent",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={(event) => {
              handleMenuOpen(event);
              handleClick();
            }}
          >
            {/* <title>Export</title> */}

            {/* SVG Content */}
            <g
              id="Layer_2"
              data-name="Layer 2"
              transform="translate(-0.75 -0.75)"
            >
              {/* <title>Export</title> */}
              <path
                id="Path_73"
                data-name="Path 73"
                d="M20.111,15.75A1.2,1.2,0,0,0,18.972,17v3a.721.721,0,0,1-.683.75H3.711A.721.721,0,0,1,3.028,20V17a1.2,1.2,0,0,0-1.139-1.25A1.2,1.2,0,0,0,.75,17v3a3.12,3.12,0,0,0,2.961,3.25H18.289A3.12,3.12,0,0,0,21.25,20V17a1.2,1.2,0,0,0-1.139-1.25Z"
                transform="translate(0 -2)"
                fill="currentColor"
              />
              <path
                id="Path_74"
                data-name="Path 74"
                d="M11,.75A1.175,1.175,0,0,0,9.922,2V13.331l-3.4-3.291A.98.98,0,0,0,5,10.2a1.393,1.393,0,0,0,.138,1.76l5.172,5a1.069,1.069,0,0,0,.172.116.991.991,0,0,0,.123.082.884.884,0,0,0,.785,0,1.1,1.1,0,0,0,.121-.081,1.077,1.077,0,0,0,.172-.116l5.172-5a1.382,1.382,0,0,0,.325-1.383,1.1,1.1,0,0,0-1.009-.828,1,1,0,0,0-.69.29l-3.4,3.291V2A1.175,1.175,0,0,0,11,.75Z"
                fill="currentColor"
              />
            </g>
          </svg>
          {isHovered && <div className={styles.answericonsTip}>Export</div>}
        </div>
        <Menu
          id="export-menu"
          anchorEl={anchorEl}
          open={exportMenuOpen}
          onClose={handleMenuClose}
        >
          <WordDownloadButton
            content={translatedMessage || answer.chat_Contnet}
          />
          <PDFDownloadButton
            content={translatedMessage || answer.chat_Contnet}
          />
          <TextDownloadButton
            content={translatedMessage || answer.chat_Contnet}
          />
        </Menu>
      </>
    );
  };

  const DislikeIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [showFeedback, setshowFeedback] = useState(false);
    const handleClick = () => {
      setshowFeedback(true);
    };

    return (
      <>
        {showFeedback && (
          <DislikePopup
            onClose={() => setshowFeedback(false)}
            message_id={answer.message_id}
          />
        )}

        <div style={{ position: "relative", display: "inline-block" }}>
          {isHovered && <div className={styles.answericonsTip}>Dislike</div>}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="icons-post"
            style={{
              cursor: "pointer",
              padding: "4px",
              borderRadius: "4px",
              color: "#5d5d5d",
              transition: "background-color 0.3s ease, border-color 0.3s ease",
              backgroundColor: isHovered ? " #f9f9f9" : "transparent",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleClick}
          >
            {/* <title>Dislike</title> */}
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.8727 21.4961C11.6725 21.8466 11.2811 22.0423 10.8805 21.9922L10.4267 21.9355C7.95958 21.6271 6.36855 19.1665 7.09975 16.7901L7.65054 15H6.93226C4.29476 15 2.37923 12.4921 3.0732 9.94753L4.43684 4.94753C4.91145 3.20728 6.49209 2 8.29589 2H18.0045C19.6614 2 21.0045 3.34315 21.0045 5V12C21.0045 13.6569 19.6614 15 18.0045 15H16.0045C15.745 15 15.5054 15.1391 15.3766 15.3644L11.8727 21.4961ZM14.0045 4H8.29589C7.39399 4 6.60367 4.60364 6.36637 5.47376L5.00273 10.4738C4.65574 11.746 5.61351 13 6.93226 13H9.00451C9.32185 13 9.62036 13.1506 9.8089 13.4059C9.99743 13.6612 10.0536 13.9908 9.96028 14.2941L9.01131 17.3782C8.6661 18.5002 9.35608 19.6596 10.4726 19.9153L13.6401 14.3721C13.9523 13.8258 14.4376 13.4141 15.0045 13.1902V5C15.0045 4.44772 14.5568 4 14.0045 4ZM17.0045 13V5C17.0045 4.64937 16.9444 4.31278 16.8338 4H18.0045C18.5568 4 19.0045 4.44772 19.0045 5V12C19.0045 12.5523 18.5568 13 18.0045 13H17.0045Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </>
    );
  };

  const SoundIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [isSelected, setIsSelected] = useState(false);
    const [speechSynthesis, setSpeechSynthesis] =
      useState<SpeechSynthesis | null>(null);

    const handleClick = () => {
      if (speechSynthesis) {
        if (!isSelected) {
          let utterance;
          if (translatedMessage && translatedLanguage) {
            utterance = new SpeechSynthesisUtterance(translatedMessage);
            utterance.lang = translatedLanguage;
          } else {
            utterance = new SpeechSynthesisUtterance(answer.chat_Contnet);
          }
          speechSynthesis.speak(utterance);
        } else {
          speechSynthesis.cancel();
        }
      }
      setIsSelected(!isSelected);
    };

    useState(() => {
      const synth = window.speechSynthesis;
      setSpeechSynthesis(synth);
    });

    return (
      <>
        <div style={{ position: "relative", display: "inline-block" }}>
          {isHovered && <div className={styles.answericonsTip}>Read Aloud</div>}
          <svg
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="icons-post"
            style={{
              cursor: "pointer",
              // border: isHovered || isSelected ? "1px solid #00000040" : "1px solid transparent",
              padding: "4px",
              borderRadius: "4px",
              // color: isHovered || isSelected ? "#fff" : "#5d5d5d",
              color: isSelected ? "#fff" : isHovered ? "#5d5d5d" : "#5d5d5d",
              transition: "background-color 0.3s ease, border-color 0.3s ease",
              // backgroundColor:
              //   isHovered || isSelected ? "#da2129" : "transparent",

              backgroundColor: isSelected
                ? "#da2128"
                : isHovered
                ? "#f9f9f9"
                : "transparent",
            }}
            onClick={handleClick}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11 4.9099C11 4.47485 10.4828 4.24734 10.1621 4.54132L6.67572 7.7372C6.49129 7.90626 6.25019 8.00005 6 8.00005H4C3.44772 8.00005 3 8.44776 3 9.00005V15C3 15.5523 3.44772 16 4 16H6C6.25019 16 6.49129 16.0938 6.67572 16.2629L10.1621 19.4588C10.4828 19.7527 11 19.5252 11 19.0902V4.9099ZM8.81069 3.06701C10.4142 1.59714 13 2.73463 13 4.9099V19.0902C13 21.2655 10.4142 22.403 8.81069 20.9331L5.61102 18H4C2.34315 18 1 16.6569 1 15V9.00005C1 7.34319 2.34315 6.00005 4 6.00005H5.61102L8.81069 3.06701ZM20.3166 6.35665C20.8019 6.09313 21.409 6.27296 21.6725 6.75833C22.5191 8.3176 22.9996 10.1042 22.9996 12.0001C22.9996 13.8507 22.5418 15.5974 21.7323 17.1302C21.4744 17.6185 20.8695 17.8054 20.3811 17.5475C19.8927 17.2896 19.7059 16.6846 19.9638 16.1962C20.6249 14.9444 20.9996 13.5175 20.9996 12.0001C20.9996 10.4458 20.6064 8.98627 19.9149 7.71262C19.6514 7.22726 19.8312 6.62017 20.3166 6.35665ZM15.7994 7.90049C16.241 7.5688 16.8679 7.65789 17.1995 8.09947C18.0156 9.18593 18.4996 10.5379 18.4996 12.0001C18.4996 13.3127 18.1094 14.5372 17.4385 15.5604C17.1357 16.0222 16.5158 16.1511 16.0539 15.8483C15.5921 15.5455 15.4632 14.9255 15.766 14.4637C16.2298 13.7564 16.4996 12.9113 16.4996 12.0001C16.4996 10.9859 16.1653 10.0526 15.6004 9.30063C15.2687 8.85905 15.3578 8.23218 15.7994 7.90049Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </>
    );
  };

  const CopyText: React.FC<React.SVGProps<SVGSVGElement>> = () => {
    const [showCopied, setShowCopied] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
      const textToCopy: any = translatedMessage || answer.chat_Contnet;
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          setShowCopied(true);
          setTimeout(() => setShowCopied(false), 2000);
        })
        .catch((error) => console.error("Error copying text: ", error));
    };

    return (
      <div style={{ position: "relative", display: "inline-block" }}>
        <svg
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleClick}
          style={{
            cursor: "pointer",
            //border: isHovered ? "1px solid #00000040" : "1px solid transparent",
            padding: "4px",
            color: "#5d5d5d",
            borderRadius: "4px",
            transition: "background-color 0.3s ease, border-color 0.3s ease",
            backgroundColor: isHovered ? " #f9f9f9" : "transparent",
          }}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="icons-post"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 5C7 3.34315 8.34315 2 10 2H19C20.6569 2 22 3.34315 22 5V14C22 15.6569 20.6569 17 19 17H17V19C17 20.6569 15.6569 22 14 22H5C3.34315 22 2 20.6569 2 19V10C2 8.34315 3.34315 7 5 7H7V5ZM9 7H14C15.6569 7 17 8.34315 17 10V15H19C19.5523 15 20 14.5523 20 14V5C20 4.44772 19.5523 4 19 4H10C9.44772 4 9 4.44772 9 5V7ZM5 9C4.44772 9 4 9.44772 4 10V19C4 19.5523 4.44772 20 5 20H14C14.5523 20 15 19.5523 15 19V10C15 9.44772 14.5523 9 14 9H5Z"
            fill="currentColor"
          ></path>
        </svg>

        {/* <img
          src={CopyImg}
          alt="Copy"
          title="Copy"
          style={{
            cursor: "pointer",
            border: isHovered ? "1px solid #00000040" : "1px solid transparent",
            padding: "2px",
            borderRadius: "5px",
            transition: "background-color 0.3s, border-color 0.3s",
            backgroundColor: isHovered ? "#00000029" : "transparent",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleClick}
        /> */}
        {isHovered && <div className={styles.answericonsTip}>Copy</div>}
        {showCopied && (
          <div
            className={styles.copiedTip}
            // style={{
            //   position: "absolute",
            //   top: "-35px",
            //   left: "50%",
            //   transform: "translateX(-50%)",
            //   backgroundColor: "#f6f6f6",
            //   color: "#0d0d0d",
            //   fontWeight:"bold",
            //   border:"1px solid #0d0d0d",
            //   padding: "4px 12px",
            //   borderRadius: "4px",
            //   zIndex: 9999,
            // }}
          >
            Copied
          </div>
        )}
      </div>
    );
  };

  const CopyImageURl: React.FC<React.SVGProps<SVGSVGElement>> = () => {
    const [showCopied, setShowCopied] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
      const source = isImageResponse
        ? resolvedImageSource
        : translatedMessage || answer.chat_Contnet;
      if (!source) {
        console.error("No image URL/text available to copy.");
        return;
      }

      let copyUrl = source;
      let createdObjectUrl: string | null = null;

      if (isImageResponse && isDataUriImage(source)) {
        copyUrl = dataUriToBlobUrl(source);
        createdObjectUrl = copyUrl;
      }

      navigator.clipboard
        .writeText(copyUrl)
        .then(() => {
          setShowCopied(true);
          setTimeout(() => setShowCopied(false), 2000);
          if (createdObjectUrl) {
            setTimeout(
              () => URL.revokeObjectURL(createdObjectUrl as string),
              5000,
            );
          }
        })
        .catch((error) => {
          if (createdObjectUrl) {
            URL.revokeObjectURL(createdObjectUrl);
          }
          console.error("Error copying text: ", error);
        });
    };

    return (
      <div style={{ position: "relative", display: "inline-block" }}>
        <svg
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleClick}
          style={{
            cursor: "pointer",
            //border: isHovered ? "1px solid #00000040" : "1px solid transparent",
            padding: "3px",
            color: "#5d5d5d",
            borderRadius: "4px",
            transition: "background-color 0.3s ease, border-color 0.3s ease",
            backgroundColor: isHovered ? " #f9f9f9" : "transparent",
          }}
          width="24"
          height="24"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.86914 22.259C3.07376 22.2582 2.3112 21.9418 1.74879 21.3794C1.18637 20.817 0.870014 20.0544 0.869141 19.259V3.25903C0.870014 2.46365 1.18637 1.7011 1.74879 1.13868C2.3112 0.576258 3.07376 0.259907 3.86914 0.259033H19.8691C20.6645 0.259907 21.4271 0.576258 21.9895 1.13868C22.5519 1.7011 22.8683 2.46365 22.8691 3.25903C22.8691 3.52425 22.7638 3.7786 22.5762 3.96614C22.3887 4.15368 22.1344 4.25903 21.8691 4.25903C21.6039 4.25903 21.3496 4.15368 21.162 3.96614C20.9745 3.7786 20.8691 3.52425 20.8691 3.25903C20.869 2.99387 20.7636 2.7396 20.5761 2.5521C20.3886 2.3646 20.1343 2.25919 19.8691 2.25903H3.86914C3.60397 2.25919 3.34971 2.3646 3.16221 2.5521C2.97471 2.7396 2.8693 2.99387 2.86914 3.25903V19.259C2.8693 19.5242 2.97471 19.7785 3.16221 19.966C3.34971 20.1535 3.60397 20.2589 3.86914 20.259C4.13436 20.259 4.38871 20.3644 4.57625 20.5519C4.76378 20.7395 4.86914 20.9938 4.86914 21.259C4.86914 21.5242 4.76378 21.7786 4.57625 21.9661C4.38871 22.1537 4.13436 22.259 3.86914 22.259Z"
            fill="currentColor"
          />
          <path
            d="M25.722 28.259H8.93719C8.10279 28.2581 7.30284 27.9262 6.71283 27.3362C6.12282 26.7462 5.79096 25.9463 5.79004 25.1119V8.32708C5.79096 7.49269 6.12282 6.69273 6.71283 6.10272C7.30284 5.51272 8.10279 5.18085 8.93719 5.17993H25.722C26.5564 5.18085 27.3563 5.51272 27.9464 6.10272C28.5364 6.69273 28.8682 7.49269 28.8691 8.32708V25.1119C28.8682 25.9463 28.5364 26.7462 27.9464 27.3362C27.3563 27.9262 26.5564 28.2581 25.722 28.259ZM8.93719 7.27803C8.65902 7.2782 8.39228 7.38878 8.19558 7.58548C7.99888 7.78217 7.88831 8.04891 7.88814 8.32708V25.1119C7.88831 25.3901 7.99888 25.6568 8.19558 25.8535C8.39228 26.0502 8.65902 26.1608 8.93719 26.1609H25.722C26.0002 26.1608 26.2669 26.0502 26.4636 25.8535C26.6603 25.6568 26.7709 25.3901 26.771 25.1119V8.32708C26.7709 8.04891 26.6603 7.78217 26.4636 7.58548C26.2669 7.38878 26.0002 7.2782 25.722 7.27803H8.93719Z"
            fill="currentColor"
          />
          <path
            d="M21.7808 19.2528C21.5732 19.2528 21.3702 19.1911 21.1977 19.0757C21.0251 18.9603 20.8906 18.7963 20.8113 18.6045C20.732 18.4126 20.7114 18.2015 20.7521 17.998C20.7928 17.7944 20.893 17.6075 21.04 17.4609L21.4119 17.0899C21.7041 16.7975 21.9359 16.4505 22.0941 16.0685C22.2522 15.6865 22.3335 15.2772 22.3335 14.8638C22.3334 14.4504 22.2519 14.0411 22.0936 13.6592C21.9353 13.2773 21.7034 12.9303 21.411 12.6381C21.1187 12.3458 20.7716 12.114 20.3897 11.9559C20.0077 11.7978 19.5983 11.7164 19.185 11.7165C18.7716 11.7166 18.3622 11.7981 17.9804 11.9563C17.5985 12.1146 17.2515 12.3465 16.9592 12.6389L16.5893 13.0098C16.3918 13.2019 16.1267 13.3086 15.8512 13.3069C15.5757 13.3052 15.312 13.1952 15.1169 13.0007C14.9218 12.8061 14.8111 12.5427 14.8086 12.2672C14.8062 11.9917 14.9122 11.7263 15.1037 11.5283L15.4746 11.1564C16.4582 10.1724 17.7924 9.61955 19.1837 9.61932C20.5749 9.6191 21.9093 10.1716 22.8932 11.1552C23.8771 12.1388 24.43 13.473 24.4303 14.8642C24.4305 16.2555 23.878 17.5899 22.8944 18.5738L22.5214 18.9457C22.4242 19.0431 22.3088 19.1203 22.1817 19.173C22.0546 19.2257 21.9183 19.2528 21.7808 19.2528Z"
            fill="currentColor"
          />
          <path
            d="M15.4762 23.8178C14.4387 23.8184 13.4243 23.5112 12.5615 22.9351C11.6987 22.359 11.0261 21.54 10.629 20.5815C10.2318 19.6231 10.1279 18.5684 10.3303 17.5508C10.5328 16.5333 11.0325 15.5987 11.7663 14.8653L12.1393 14.4934C12.3373 14.3018 12.6027 14.1958 12.8781 14.1983C13.1536 14.2008 13.4171 14.3115 13.6116 14.5066C13.8062 14.7016 13.9162 14.9654 13.9179 15.2409C13.9196 15.5164 13.8129 15.7815 13.6208 15.9789L13.2488 16.3499C12.6586 16.9404 12.3271 17.7411 12.3273 18.576C12.3273 18.9894 12.4088 19.3987 12.5671 19.7806C12.7254 20.1625 12.9573 20.5095 13.2497 20.8017C13.542 21.094 13.8891 21.3258 14.2711 21.4839C14.653 21.6421 15.0624 21.7234 15.4758 21.7233C16.3106 21.7232 17.1112 21.3914 17.7015 20.8009L18.0714 20.43C18.2689 20.2379 18.534 20.1312 18.8095 20.1329C19.085 20.1346 19.3487 20.2446 19.5438 20.4391C19.7389 20.6337 19.8496 20.8971 19.8521 21.1726C19.8545 21.4481 19.7486 21.7135 19.557 21.9115L19.1861 22.2834C18.6993 22.771 18.1209 23.1575 17.4842 23.4208C16.8476 23.6841 16.1651 23.819 15.4762 23.8178Z"
            fill="currentColor"
          />
          <path
            d="M16.218 18.8814C16.0105 18.8814 15.8077 18.8199 15.6352 18.7046C15.4627 18.5893 15.3282 18.4255 15.2488 18.2338C15.1694 18.0421 15.1486 17.8312 15.1891 17.6277C15.2295 17.4242 15.3294 17.2373 15.4761 17.0906L18.4432 14.1235C18.6408 13.9309 18.9064 13.824 19.1823 13.8258C19.4583 13.8277 19.7224 13.9382 19.9174 14.1334C20.1125 14.3285 20.2228 14.5927 20.2244 14.8687C20.2261 15.1446 20.119 15.4101 19.9263 15.6076L16.9592 18.5747C16.8619 18.6721 16.7464 18.7493 16.6192 18.802C16.492 18.8546 16.3556 18.8816 16.218 18.8814Z"
            fill="currentColor"
          />
        </svg>
        {/* <svg
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleClick}
          style={{
            cursor: "pointer",
            //border: isHovered ? "1px solid #00000040" : "1px solid transparent",
            padding: "4px",
            color: "#5d5d5d",
            borderRadius: "4px",
            transition: "background-color 0.3s ease, border-color 0.3s ease",
            backgroundColor: isHovered ? " #f9f9f9" : "transparent",
          }}
          width="24"
          height="24"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.8691 28.259H9.86914C9.07376 28.2582 8.3112 27.9418 7.74879 27.3794C7.18637 26.817 6.87001 26.0544 6.86914 25.259V9.25903C6.87001 8.46365 7.18637 7.7011 7.74879 7.13868C8.3112 6.57626 9.07376 6.25991 9.86914 6.25903H25.8691C26.6645 6.25991 27.4271 6.57626 27.9895 7.13868C28.5519 7.7011 28.8683 8.46365 28.8691 9.25903V25.259C28.8683 26.0544 28.5519 26.817 27.9895 27.3794C27.4271 27.9418 26.6645 28.2582 25.8691 28.259ZM9.86914 8.25903C9.60397 8.25919 9.34971 8.3646 9.16221 8.5521C8.97471 8.7396 8.8693 8.99387 8.86914 9.25903V25.259C8.8693 25.5242 8.97471 25.7785 9.16221 25.966C9.34971 26.1535 9.60397 26.2589 9.86914 26.259H25.8691C26.1343 26.2589 26.3886 26.1535 26.5761 25.966C26.7636 25.7785 26.869 25.5242 26.8691 25.259V9.25903C26.869 8.99387 26.7636 8.7396 26.5761 8.5521C26.3886 8.3646 26.1343 8.25919 25.8691 8.25903H9.86914Z"
            fill="currentColor"
          />
          <path
            d="M3.86914 22.259C3.07376 22.2582 2.3112 21.9418 1.74879 21.3794C1.18637 20.817 0.870014 20.0544 0.869141 19.259V3.25903C0.870014 2.46365 1.18637 1.7011 1.74879 1.13868C2.3112 0.576258 3.07376 0.259907 3.86914 0.259033H19.8691C20.6645 0.259907 21.4271 0.576258 21.9895 1.13868C22.5519 1.7011 22.8683 2.46365 22.8691 3.25903C22.8691 3.52425 22.7638 3.7786 22.5762 3.96614C22.3887 4.15368 22.1344 4.25903 21.8691 4.25903C21.6039 4.25903 21.3496 4.15368 21.162 3.96614C20.9745 3.7786 20.8691 3.52425 20.8691 3.25903C20.869 2.99387 20.7636 2.7396 20.5761 2.5521C20.3886 2.3646 20.1343 2.25919 19.8691 2.25903H3.86914C3.60397 2.25919 3.34971 2.3646 3.16221 2.5521C2.97471 2.7396 2.8693 2.99387 2.86914 3.25903V19.259C2.8693 19.5242 2.97471 19.7785 3.16221 19.966C3.34971 20.1535 3.60397 20.2589 3.86914 20.259C4.13436 20.259 4.38871 20.3644 4.57625 20.5519C4.76378 20.7395 4.86914 20.9938 4.86914 21.259C4.86914 21.5242 4.76378 21.7786 4.57625 21.9661C4.38871 22.1537 4.13436 22.259 3.86914 22.259Z"
            fill="currentColor"
          />
          <path
            d="M22.1114 19.6731C21.9135 19.6731 21.7201 19.6144 21.5556 19.5044C21.3911 19.3943 21.263 19.238 21.1874 19.0552C21.1118 18.8723 21.0921 18.6711 21.1309 18.4771C21.1697 18.283 21.2652 18.1048 21.4053 17.9651L21.7598 17.6115C22.0384 17.3328 22.2593 17.002 22.4101 16.638C22.5608 16.2739 22.6383 15.8837 22.6382 15.4897C22.6382 15.0957 22.5605 14.7055 22.4096 14.3415C22.2588 13.9775 22.0377 13.6468 21.759 13.3682C21.4804 13.0896 21.1495 12.8687 20.7855 12.718C20.4214 12.5672 20.0312 12.4897 19.6372 12.4898C19.2432 12.4899 18.853 12.5675 18.489 12.7184C18.125 12.8693 17.7943 13.0903 17.5157 13.369L17.1631 13.7225C16.9749 13.9056 16.7222 14.0073 16.4596 14.0057C16.197 14.0041 15.9456 13.8992 15.7597 13.7138C15.5738 13.5284 15.4682 13.2773 15.4659 13.0147C15.4635 12.7521 15.5645 12.4991 15.7471 12.3104L16.1006 11.9559C17.0382 11.0181 18.3099 10.4911 19.636 10.4908C20.9621 10.4906 22.2339 11.0172 23.1718 11.9548C24.1096 12.8923 24.6366 14.164 24.6368 15.4901C24.637 16.8162 24.1105 18.0881 23.1729 19.0259L22.8174 19.3804C22.7248 19.4732 22.6147 19.5468 22.4936 19.597C22.3724 19.6473 22.2426 19.6731 22.1114 19.6731Z"
            fill="currentColor"
          />
          <path
            d="M16.1015 24.0247C15.1126 24.0252 14.1458 23.7324 13.3234 23.1833C12.501 22.6342 11.8599 21.8535 11.4813 20.94C11.1028 20.0264 11.0037 19.0211 11.1967 18.0512C11.3896 17.0814 11.866 16.1905 12.5654 15.4915L12.9209 15.137C13.1096 14.9544 13.3626 14.8533 13.6252 14.8557C13.8878 14.858 14.1389 14.9636 14.3243 15.1495C14.5097 15.3355 14.6146 15.5869 14.6162 15.8495C14.6178 16.112 14.5161 16.3647 14.333 16.553L13.9785 16.9066C13.4159 17.4694 13.0999 18.2326 13.1001 19.0284C13.1002 19.4224 13.1778 19.8126 13.3287 20.1766C13.4796 20.5406 13.7006 20.8713 13.9793 21.1499C14.258 21.4284 14.5888 21.6494 14.9529 21.8001C15.3169 21.9508 15.7071 22.0283 16.1011 22.0283C16.8969 22.0281 17.66 21.7119 18.2226 21.1491L18.5752 20.7956C18.7634 20.6124 19.0161 20.5107 19.2787 20.5124C19.5413 20.514 19.7927 20.6188 19.9786 20.8042C20.1646 20.9897 20.2701 21.2408 20.2725 21.5034C20.2748 21.766 20.1738 22.0189 19.9912 22.2077L19.6377 22.5622C19.1737 23.0268 18.6224 23.3953 18.0155 23.6462C17.4087 23.8972 16.7582 24.0258 16.1015 24.0247Z"
            fill="currentColor"
          />
          <path
            d="M16.8095 19.3195C16.6117 19.3195 16.4184 19.2608 16.254 19.151C16.0895 19.0411 15.9614 18.8849 15.8857 18.7022C15.81 18.5195 15.7902 18.3185 15.8288 18.1245C15.8673 17.9305 15.9625 17.7524 16.1024 17.6125L18.9305 14.7844C19.1188 14.6009 19.372 14.4989 19.635 14.5007C19.898 14.5025 20.1497 14.6078 20.3357 14.7938C20.5216 14.9799 20.6267 15.2317 20.6283 15.4947C20.6299 15.7577 20.5277 16.0108 20.3441 16.199L17.516 19.0271C17.4232 19.12 17.3131 19.1936 17.1919 19.2438C17.0706 19.2939 16.9407 19.3197 16.8095 19.3195Z"
            fill="currentColor"
          />
        </svg> */}

        {/* <img
          src={CopyImg}
          alt="Copy"
          title="Copy"
          style={{
            cursor: "pointer",
            border: isHovered ? "1px solid #00000040" : "1px solid transparent",
            padding: "2px",
            borderRadius: "5px",
            transition: "background-color 0.3s, border-color 0.3s",
            backgroundColor: isHovered ? "#00000029" : "transparent",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleClick}
        /> */}
        {isHovered && (
          <div className={styles.answericonsTip}>Copy Image Address</div>
        )}
        {showCopied && (
          <div
            className={styles.copiedTip}
            // style={{
            //   position: "absolute",
            //   top: "-35px",
            //   left: "50%",
            //   transform: "translateX(-50%)",
            //   backgroundColor: "#f6f6f6",
            //   color: "#0d0d0d",
            //   fontWeight:"bold",
            //   border:"1px solid #0d0d0d",
            //   padding: "4px 12px",
            //   borderRadius: "4px",
            //   zIndex: 9999,
            // }}
          >
            Copied
          </div>
        )}
      </div>
    );
  };
  const AvtarIcon: React.FC = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [showNewComponent, setShowNewComponent] = useState(false);

    const handleClick = () => {
      setShowNewComponent(true); // Set to true to render the Avatar component
    };

    return (
      <div
        style={{
          display: "inline-block",
          position: "relative",
        }}
      >
        <img
          src={AvtarImg}
          className={styles.avtarStyle}
          // style={{
          //   cursor: "pointer",
          //   border: "1px solid transparent",
          //   padding: "2px",
          //   borderRadius: "5px",
          //   transition: "background-color 0.3s, border-color 0.3s, filter 0.3s",
          //   backgroundColor: "transparent",
          //   height: "30px",
          //   filter: "grayscale(100%)",
          // }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleClick}
        />

        {isHovered && <div className={styles.answericonsTip}>Avatar</div>}
      </div>
    );
  };

  const LikeIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [showFeedbackforLike, setshowFeedbackforLike] = useState(false);
    const handleClick = () => {
      setshowFeedbackforLike(true);
    };
    return (
      <>
        {showFeedbackforLike && (
          <LikePopup
            onClose={() => setshowFeedbackforLike(false)}
            message_id={answer.message_id}
          />
        )}

        <div style={{ position: "relative", display: "inline-block" }}>
          {isHovered && <div className={styles.answericonsTip}>Like</div>}
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            className="icons-post"
            style={{
              cursor: "pointer",
              // border: isHovered ? "1px solid #00000040" : "1px solid transparent",
              padding: "4px",
              borderRadius: "4px",
              color: "#5d5d5d",
              transition: "background-color 0.3s ease, border-color 0.3s ease",
              backgroundColor: isHovered ? " #f9f9f9" : "transparent",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            // onClick={()=>setshowFeedbackforLike(true)}
            onClick={handleClick}
          >
            {/* <title>Like</title> */}
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.1318 2.50389C12.3321 2.15338 12.7235 1.95768 13.124 2.00775L13.5778 2.06447C16.0449 2.37286 17.636 4.83353 16.9048 7.20993L16.354 8.99999H17.0722C19.7097 8.99999 21.6253 11.5079 20.9313 14.0525L19.5677 19.0525C19.0931 20.7927 17.5124 22 15.7086 22H6C4.34315 22 3 20.6568 3 19V12C3 10.3431 4.34315 8.99999 6 8.99999H8C8.25952 8.99999 8.49914 8.86094 8.6279 8.63561L12.1318 2.50389ZM10 20H15.7086C16.6105 20 17.4008 19.3964 17.6381 18.5262L19.0018 13.5262C19.3488 12.2539 18.391 11 17.0722 11H15C14.6827 11 14.3841 10.8494 14.1956 10.5941C14.0071 10.3388 13.9509 10.0092 14.0442 9.70591L14.9932 6.62175C15.3384 5.49984 14.6484 4.34036 13.5319 4.08468L10.3644 9.62789C10.0522 10.1742 9.56691 10.5859 9 10.8098V19C9 19.5523 9.44772 20 10 20ZM7 11V19C7 19.3506 7.06015 19.6872 7.17071 20H6C5.44772 20 5 19.5523 5 19V12C5 11.4477 5.44772 11 6 11H7Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </>
    );
  };

  const iconStyle = {
    width: "16px",
    // height: "auto",
    height: "16px",
    marginRight: "7px",
    fontSize: "14px",
  };

  const MenuDropdown = () => {
    const [exportMenu, setExportMenu] = useState<HTMLElement | null>(null);
    const [showTranslate, setshowTranslate] = useState(false);
    const GettranslatedMessage = (translatedText: any) => {
      settranslatedMessage(translatedText.text);
      settranslatedLanguage(translatedText.language);
    };
    const [isHovered, setIsHovered] = useState(false);

    const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
      setExportMenu(event.currentTarget);
    };

    const handleClose = () => {
      setExportMenu(null);
    };

    const handleOutlookDraft = () => {
      const subject = answer.userQuestion;
      const markdownContent: any = parsedAnswer.markdownFormatText;
      const mailtoLink = `mailto:?subject=${encodeURIComponent(
        subject,
      )}&body=${encodeURIComponent(markdownContent)}`;
      window.location.href = mailtoLink;
    };

    const handleShare = () => {
      const messageContent: any = answer.chat_Contnet;
      const encodedText = encodeURIComponent(messageContent);
      const deepLink = `https://teams.microsoft.com/l/chat/0/0?users=&topicName=Topic&message=${encodedText}`;

      navigator.clipboard
        .writeText(messageContent)
        .then(() => {
          toast.success("Content is copied", { autoClose: 1000 });

          setTimeout(() => {
            toast.info("Opening Teams", { autoClose: 1000 });

            setTimeout(() => {
              window.open(deepLink, "_blank");
            }, 1000);
          }, 1000);
        })
        .catch((err) => {
          console.error("Error copying text: ", err);
        });

      handleClose();
    };

    function handleTranslate(): void {
      setshowTranslate(!showTranslate);
    }

    return (
      <>
        <div style={{ position: "relative", display: "inline-block" }}>
          {isHovered && (
            <div className={styles.answericonsTip}>More Options</div>
          )}

          <svg
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            strokeWidth="0"
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            className="icons-post"
            style={{
              cursor: "pointer",
              padding: "6px",
              borderRadius: "4px",
              color: "#5d5d5d",
              transition: "background-color 0.3s ease, border-color 0.3s ease",
            }}
            title="More Options"
            /*@ts-ignore*/
            onClick={handleButtonClick}
            stroke="currentColor"
            fill="currentColor"
          >
            <path d="M388.8 896.4v-27.198c.6-2.2 1.6-4.2 2-6.4 8.8-57.2 56.4-102.4 112.199-106.2 62.4-4.4 115.2 31.199 132.4 89.199 2.2 7.6 3.8 15.6 5.8 23.4v27.2c-.6 1.8-1.6 3.399-1.8 5.399-8.6 52.8-46.6 93-98.6 104.4-4 .8-8 2-12 3h-27.2c-1.8-.6-3.6-1.6-5.4-1.8-52-8.4-91.599-45.4-103.6-96.8-1.2-5-2.6-9.6-3.8-14.2zm252.4-768.797l-.001 27.202c-.6 2.2-1.6 4.2-1.8 6.4-9 57.6-56.8 102.6-113.2 106.2-62.2 4-114.8-32-131.8-90.2-2.2-7.401-3.8-15-5.6-22.401v-27.2c.6-1.8 1.6-3.4 2-5.2 9.6-52 39.8-86 90.2-102.2 6.6-2.2 13.6-3.4 20.4-5.2h27.2c1.8.6 3.6 1.6 5.4 1.8 52.2 8.6 91.6 45.4 103.6 96.8 1.201 4.8 2.401 9.4 3.601 13.999zm-.001 370.801v27.2c-.6 2.2-1.6 4.2-2 6.4-9 57.4-58.6 103.6-114.6 106-63 2.8-116.4-35.2-131.4-93.8-1.6-6.2-3-12.4-4.4-18.6v-27.2c.6-2.2 1.6-4.2 2-6.4 8.8-57.4 58.6-103.601 114.6-106.2 63-3 116.4 35.2 131.4 93.8 1.6 6.4 3 12.6 4.4 18.8z"></path>
          </svg>

          {/* <img
            src={MenuImg}
            alt="Menu Icon"
            style={{
              cursor: "pointer",
              padding: "2px",
              borderRadius: "5px",
              transition: "background-color 0.3s, border-color 0.3s",
              height: "24px",
              width: "23px",
            }}
            onClick={handleButtonClick}
            title="More Options"
          /> */}
          <Menu
            id="export-menu"
            anchorEl={exportMenu}
            open={Boolean(exportMenu)}
            onClose={handleClose}
          >
            <MenuItem className={styles.msMenuItem} onClick={handleShare}>
              <img src={ShareImg} alt="Share" className={styles.msIcons} />
              <span className={styles.msIconsThree}>Share on MsTeams</span>
            </MenuItem>
            <MenuItem
              className={styles.msMenuItem}
              onClick={handleOutlookDraft}
            >
              <img src={Outlook} alt="Outlook" className={styles.msIcons} />
              <span className={styles.msIconsThree}> Draft in Outlook</span>
            </MenuItem>
            <MenuItem className={styles.msMenuItem} onClick={handleTranslate}>
              <img src={translateIcon} alt="Share" className={styles.msIcons} />
              <span className={styles.msIconsThree}>Translate</span>
            </MenuItem>
          </Menu>
        </div>
        <ToastContainer />
        {showTranslate && (
          <Translate
            ChatConent={answer.chat_Contnet}
            onMessageSend={GettranslatedMessage}
          />
        )}
      </>
    );
  };

  const handleImageClick = () => {
    setIsFullScreen(true);
  };

  const closeFullScreen = () => {
    setIsFullScreen(false);
  };
  const selectAivalue = appStateContext?.state.selectedAI;
  const renderedAnswerContent =
    translatedMessage || parsedAnswer.markdownFormatText || "";
  const extractImageUrlFromLoosePayload = (value: string): string | null => {
    const trimmedValue = String(value || "").trim();
    if (!trimmedValue) return null;

    const directUrlMatch = trimmedValue.match(
      /https?:\/\/[^\s)"\]]+\.(png|jpe?g|gif|webp|bmp|svg)(\?[^\s)"\]]*)?/i,
    )?.[0];
    if (directUrlMatch) {
      return directUrlMatch;
    }

    if (!trimmedValue.startsWith("[") && !trimmedValue.startsWith("{")) {
      return null;
    }

    try {
      const parsedValue = JSON.parse(trimmedValue);
      if (Array.isArray(parsedValue)) {
        const firstUrl = parsedValue.find(
          (item) => typeof item === "string" && /^https?:\/\//i.test(item),
        );
        return typeof firstUrl === "string" ? firstUrl : null;
      }

      if (parsedValue && typeof parsedValue === "object") {
        const objectUrl =
          typeof parsedValue.image_url === "string"
            ? parsedValue.image_url
            : typeof parsedValue.imageUrl === "string"
            ? parsedValue.imageUrl
            : typeof parsedValue.url === "string"
            ? parsedValue.url
            : null;
        return objectUrl && /^https?:\/\//i.test(objectUrl) ? objectUrl : null;
      }
    } catch {
      return null;
    }

    return null;
  };
  const extractedBase64Image = renderedAnswerContent.match(
    /data:image\/[a-zA-Z0-9.+-]+;base64,[A-Za-z0-9+/=\r\n]+/i,
  )?.[0];

  // Extract image URL from content - check for direct URLs (http:// or https://)
  const extractedImageUrl = extractImageUrlFromLoosePayload(
    renderedAnswerContent,
  );

  // 🖼️ REFERENCE FORMAT - Check explicit isImage flag first
  const normalizedAnswerImageUrl =
    (typeof answer.imageUrl === "string" &&
      extractImageUrlFromLoosePayload(answer.imageUrl)) ||
    (typeof answer.image_url === "string" &&
      extractImageUrlFromLoosePayload(answer.image_url)) ||
    null;
  const finalImageUrl = normalizedAnswerImageUrl || extractedImageUrl || null;
  const resolvedImageSource = extractedBase64Image
    ? extractedBase64Image.replace(/\s+/g, "")
    : finalImageUrl || renderedAnswerContent.trim();

  const isImageResponse =
    answer.isImage ||
    /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(resolvedImageSource) ||
    /^data:image\/[a-zA-Z0-9.+-]+;base64,/i.test(resolvedImageSource) ||
    /^https?:\/\//i.test(resolvedImageSource); // Check if it's a URL

  // 🔍 DEBUG: Log Answer Component Image Detection - Reference Format
  if (answer.chat_Contnet || renderedAnswerContent) {
    console.log("\n" + "═".repeat(70));
    console.log("🎨 ANSWER COMPONENT - IMAGE DETECTION (Reference Format):");
    console.log("═".repeat(70));
    console.log("Answer Properties:");
    console.log("  - isImage flag:", answer.isImage);
    console.log("  - imageUrl prop:", answer.imageUrl);
    console.log("  - image_url prop:", answer.image_url);
    console.log("\nContent Analysis:");
    console.log(
      "  - Rendered Content:",
      renderedAnswerContent.substring(0, 100),
    );
    console.log("  - Extracted Base64:", !!extractedBase64Image);
    console.log("  - Extracted URL:", extractedImageUrl);
    console.log("  - Final Image URL:", finalImageUrl);
    console.log("\nResolution:");
    console.log("  - Resolved Source:", resolvedImageSource.substring(0, 100));
    console.log("  - Is Image Response:", isImageResponse);
    console.log("═".repeat(70) + "\n");
  }

  const isDataUriImage = (src: string) =>
    /^data:image\/[a-zA-Z0-9.+-]+;base64,/i.test(src);

  const dataUriToBlobUrl = (dataUri: string): string => {
    const base64Data = dataUri.split(",")[1] || "";
    const mimeType = dataUri.split(",")[0].split(":")[1].split(";")[0];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    return URL.createObjectURL(blob);
  };

  const DownloadImageIcon: React.FC = () => {
    const imageUrl: any = resolvedImageSource;
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
      if (
        isImageResponse &&
        /^data:image\/[a-zA-Z0-9.+-]+;base64,/i.test(imageUrl)
      ) {
        // Handle base64 image download
        const base64Data = imageUrl.split(",")[1];
        const mimeType = imageUrl.split(",")[0].split(":")[1].split(";")[0];
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `image.${mimeType.split("/")[1]}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else {
        // Handle regular URL download
        const a = document.createElement("a");
        a.href = imageUrl;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    };

    return (
      <div
        style={{
          position: "relative",
          display: "inline-block",
        }}
      >
        <svg
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleClick}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20.5 20.5"
          className="icons-post"
          style={{
            cursor: "pointer",
            padding: "6px",
            borderRadius: "4px",
            color: "#5d5d5d",
            transition: "background-color 0.3s ease, border-color 0.3s ease",
          }}
        >
          <g
            id="Layer_2"
            data-name="Layer 2"
            transform="translate(-0.75 -0.75)"
          >
            <path
              id="Path_73"
              data-name="Path 73"
              d="M20.111,15.75A1.2,1.2,0,0,0,18.972,17v3a.721.721,0,0,1-.683.75H3.711A.721.721,0,0,1,3.028,20V17a1.2,1.2,0,0,0-1.139-1.25A1.2,1.2,0,0,0,.75,17v3a3.12,3.12,0,0,0,2.961,3.25H18.289A3.12,3.12,0,0,0,21.25,20V17a1.2,1.2,0,0,0-1.139-1.25Z"
              transform="translate(0 -2)"
              fill="currentColor"
            />
            <path
              id="Path_74"
              data-name="Path 74"
              d="M11,.75A1.175,1.175,0,0,0,9.922,2V13.331l-3.4-3.291A.98.98,0,0,0,5,10.2a1.393,1.393,0,0,0,.138,1.76l5.172,5a1.069,1.069,0,0,0,.172.116.991.991,0,0,0,.123.082.884.884,0,0,0,.785,0,1.1,1.1,0,0,0,.121-.081,1.077,1.077,0,0,0,.172-.116l5.172-5a1.382,1.382,0,0,0,.325-1.383,1.1,1.1,0,0,0-1.009-.828,1,1,0,0,0-.69.29l-3.4,3.291V2A1.175,1.175,0,0,0,11,.75Z"
              fill="currentColor"
            />
          </g>
        </svg>
        {isHovered && (
          <div
            style={{
              position: "absolute",
              top: "-204%",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "#0d0d0d",
              color: "#ebebeb",
              fontWeight: "600",
              lineHeight: "1.2",
              padding: "0.75rem 0.75rem",
              borderRadius: "0.5rem",
              fontSize: "0.8125rem",
              whiteSpace: "nowrap",
              zIndex: 1000,
            }}
          >
            Download Image
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {isImageResponse ? (
        <Stack className={styles.imageContainer} tabIndex={0}>
          <Stack.Item grow>
            <img
              src={resolvedImageSource}
              alt="Parsed content"
              className={styles.image}
              onClick={handleImageClick}
            />
          </Stack.Item>
          <div className={styles.iconContainer}>
            <LikeIcon className={styles.icon} />
            <DislikeIcon className={styles.icon} />
            {selectAivalue !== "Nano Banana" &&
              selectAivalue !== "NanoBanana" && (
                <>
                  <CopyImageURl data-tooltip-id="ImageCopy" />
                  <ReactTooltip
                    className={styles.customTooltip}
                    id="ImageCopy"
                    place="top"
                    content="Copy Image Address"
                  />
                </>
              )}
            <DownloadImageIcon data-tooltip-id="DownloadImage" />
            <ReactTooltip
              className={styles.customTooltip}
              id="DownloadImage"
              place="top"
              content="Download Image"
            />
          </div>

          {isFullScreen && (
            <div className={styles.fullScreenOverlay} onClick={closeFullScreen}>
              <img
                src={resolvedImageSource}
                alt="Full screen view"
                className={styles.fullScreenImage}
              />
              <button className={styles.closeButton} onClick={closeFullScreen}>
                &times;
              </button>
            </div>
          )}
        </Stack>
      ) : (
        <Stack className={styles.answerContainer} tabIndex={0}>
          <Stack.Item grow>
            <ReactMarkdown
              linkTarget="_blank"
              remarkPlugins={[remarkGfm, supersub]}
              children={translatedMessage || parsedAnswer.markdownFormatText}
              className={styles.answerText}
            />
            <div className={styles.policy_pdf}>
              {Array.isArray(answer?.fileUrl) && answer.fileUrl.length > 0
                ? answer.fileUrl.map(
                    (filePair: [string, string], index: number) => {
                      if (!Array.isArray(filePair) || filePair.length < 2)
                        return null;

                      const [fileName, fileUrl] = filePair;

                      return (
                        <div key={index}>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = "#e4ecff";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = "#f1f5ff";
                            }}
                          >
                            <span role="img" aria-label="file">
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth="0"
                                viewBox="0 0 16 16"
                                height="16"
                                width="16"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M5.523 12.424q.21-.124.459-.238a8 8 0 0 1-.45.606c-.28.337-.498.516-.635.572l-.035.012a.3.3 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548m2.455-1.647q-.178.037-.356.078a21 21 0 0 0 .5-1.05 12 12 0 0 0 .51.858q-.326.048-.654.114m2.525.939a4 4 0 0 1-.435-.41q.344.007.612.054c.317.057.466.147.518.209a.1.1 0 0 1 .026.064.44.44 0 0 1-.06.2.3.3 0 0 1-.094.124.1.1 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256M8.278 6.97c-.04.244-.108.524-.2.829a5 5 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.5.5 0 0 1 .145-.04c.013.03.028.092.032.198q.008.183-.038.465z"></path>
                                <path
                                  fillRule="evenodd"
                                  d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2zM4.165 13.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.7 11.7 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.86.86 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.84.84 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.8 5.8 0 0 0-1.335-.05 11 11 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.24 1.24 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a20 20 0 0 1-1.062 2.227 7.7 7.7 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103"
                                ></path>
                              </svg>
                            </span>
                            {fileName}
                          </a>
                        </div>
                      );
                    },
                  )
                : null}
            </div>
          </Stack.Item>
          <Stack horizontal className={styles.answerFooter}>
            {!!parsedAnswer.citations.length && (
              <Stack.Item
                onKeyDown={(e) =>
                  e.key === "Enter" || e.key === " "
                    ? toggleIsRefAccordionOpen()
                    : null
                }
              >
                <Stack style={{ width: "100%", marginBottom: 10 }}>
                  <Stack
                    horizontal
                    horizontalAlign="start"
                    verticalAlign="center"
                  >
                    <Text
                      className={styles.accordionTitle}
                      onClick={toggleIsRefAccordionOpen}
                      aria-label="Open references"
                      tabIndex={0}
                      role="button"
                    >
                      <span>
                        {parsedAnswer.citations.length > 1
                          ? parsedAnswer.citations.length + " references"
                          : "1 reference"}
                      </span>
                    </Text>
                    <FontIcon
                      className={styles.accordionIcon}
                      onClick={handleChevronClick}
                      iconName={
                        chevronIsExpanded ? "ChevronDown" : "ChevronRight"
                      }
                    />
                  </Stack>
                </Stack>
              </Stack.Item>
            )}

            {
              <Stack.Item className={styles.answerDisclaimerContainer}>
                <span className={styles.answerDisclaimer}>
                  AI-generated content may be incorrect
                </span>
              </Stack.Item>
            }
          </Stack>
          {chevronIsExpanded && (
            <div
              style={{
                marginTop: 0,
                display: "flex",
                flexFlow: "wrap column",
                maxHeight: "150px",
                gap: "4px",
              }}
            >
              {parsedAnswer.citations.map((citation, idx) => {
                return (
                  <div
                    className={styles.dcmttWrp}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <span
                      title={createCitationFilepath(citation, ++idx)}
                      tabIndex={0}
                      role="link"
                      key={idx}
                      onClick={() => onCitationClicked(citation)}
                      onKeyDown={(e) =>
                        e.key === "Enter" || e.key === " "
                          ? onCitationClicked(citation)
                          : null
                      }
                      className={styles.citationContainer}
                      aria-label={createCitationFilepath(citation, idx)}
                    >
                      <div className={styles.citation}>{idx}</div>
                      {createCitationFilepath(citation, idx, true)}
                    </span>

                    <FontIcon
                      aria-label="Compass"
                      style={{ marginLeft: "10" }}
                      className={styles.viewEye}
                      title="View Document"
                      iconName="RedEye"
                      onClick={() => eyeHandle(citation)}
                    />
                  </div>
                );
              })}
            </div>
          )}

          {/* {parsedAnswer.markdownFormatText !== "Generating answer..." && ( */}
          {/* {!answer.isLoading && ( */}
          <>
            <hr
              className="hr_style"
              // style={{ width: "100%", border: "1px solid #d1d1d1" }}
            />

            <div className={styles.answersSharingActivity}>
              <LikeIcon data-tooltip-id="answerLike" />
              <ReactTooltip
                className={styles.customTooltip}
                id="answerLike"
                place="top"
                content="Send Attachment"
              />
              <DislikeIcon data-tooltip-id="answerDislike" />
              <ReactTooltip
                className={styles.customTooltip}
                id="answerDislike"
                place="top"
                content="Send Attachment"
              />
              <CopyText data-tooltip-id="answerCopy" />
              <ReactTooltip
                className={styles.customTooltip}
                id="answerCopy"
                place="top"
                content="Send Attachment"
              />
              <DownloadIcon data-tooltip-id="answerDownload" />
              <ReactTooltip
                className={styles.customTooltip}
                id="answerDownload"
                place="top"
                content="Send Attachment"
              />
              <SoundIcon data-tooltip-id="answerReadAloud" />
              <ReactTooltip
                className={styles.customTooltip}
                id="answerReadAloud"
                place="top"
                content="Read Aloud"
              />
              <AvtarIcon data-tooltip-id="answerAvtar" />
              <ReactTooltip
                className={styles.customTooltip}
                id="answerAvtar"
                place="top"
                content="Avtar"
              />
              <MenuDropdown data-tooltip-id="answerMenu" />
              <ReactTooltip
                className={styles.customTooltip}
                id="answerMenu"
                place="top"
                content="Menu"
              />
              {/* {parsedAnswer.markdownFormatText !== "Generating answer..." && (
                        <span className={styles.copybtn} onClick={copyAnser}>
                            <img src={copy} alt={parsedAnswer.markdownFormatText} />
                        </span>
                    )} */}
            </div>
          </>
          {/* )} */}
        </Stack>
      )}
    </>
  );
};
